import React from 'react';
import './services.css'
import { FaAngleDown } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';


export default function ServicesLanding() {
    const navigate = useNavigate()
    return (
        <div className="custom-background-image w-full h-screen bg-contain bg-no-repeat  "
        >
            <div>
                <div className=' flex flex-col items-center gap-2 md:gap-4 py-8 md:py-16 px-4 sm:px-8 lg:px-16 relative z-10 '>
                    <h1 className="text-2xl font-pop text-[#868686] lg:text-3xl font-normal my-4 text-center">OUR SERVICES</h1>
                    <h1 className=' text-4xl md:text-5xl font-pop font-semibold text-center'>Welcome to <span className='italic text-primarygreen'>Paycott</span></h1>
                    <p className='text-center font-pop text-base max-w-[100%] md:max-w-[60%] xl:max-w-[50%] md:m-auto my-4 mx-4'>Your trusted partner for secure and successful trading in the digital realm. We take pride in offering you an innovative marketplace that connects buyers and sellers from around the world. Whether you're looking for talented freelancers or high-quality physical goods, you’ve come to the right place.</p>
                    <button
                        className='bg-primarygreen text-white font-pop rounded-full my-6 py-3 px-8 border-2 border-primarygreen text-lg hover:bg-transparent hover:text-primarygreen ease-in-out duration-300'
                        onClick={() => {
                            navigate('/signup')
                        }}
                    >
                        Get Started
                    </button>
                </div>
                <button className='flex flex-col items-center mx-auto' onClick={() => {

                    const element = document.getElementById('services');
                    element?.scrollIntoView(
                        {
                            behavior: 'smooth'
                        }
                    )


                }}  >
                    <span className='text-center font-pop text-base'>Services</span>
                    <FaAngleDown />
                </button>
            </div>
        </div >
    );
}
